import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { styled } from '@mui/material/styles';
import MuiAppBar, { AppBarProps as MuiAppBarProps } from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import { Avatar, Stack } from '@mui/material';
import { AppDispatch } from 'redux/store';
import Routes from 'constants/routes';

import Colors from 'constants/colors';
import glory_icon from 'assets/glory_icon.png';
import { SEND_MONEY } from 'types/sendAndRequest';
import { setSendAndRequestTab } from 'redux/slices/common/appSlice';

const drawerWidth = 2;
interface AppBarProps extends MuiAppBarProps {
    open?: boolean;
}

const AppBar = styled(MuiAppBar, {
    shouldForwardProp: (prop) => prop !== 'open',
})<AppBarProps>(({ theme, open }) => ({
    transition: theme.transitions.create(['margin', 'width'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    zIndex: theme.zIndex.drawer + 1,
    ...(open && {
        width: `calc(100% - ${drawerWidth}px)`,
        marginLeft: `${drawerWidth}px`,
        transition: theme.transitions.create(['margin', 'width'], {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
        }),
    }),
}));

interface AppBarComponentProps {
    open: boolean;
    handleDrawerOpen: () => void;
    handleDrawerClose: () => void;
    hideMenuIcon?: boolean;
}
export default function AppBarComponent({ open, handleDrawerOpen, handleDrawerClose, hideMenuIcon }: AppBarComponentProps) {
    const dispatch = useDispatch<AppDispatch>();
    const navigate = useNavigate();
    const navigationHandler = () => {
        if (open) {
            handleDrawerClose();
        } else {
            handleDrawerOpen();
        }
    };

    const handleNotificationClick = async () => {
        dispatch(setSendAndRequestTab(SEND_MONEY));
        navigate(Routes.sendAndRequest.main);
    };

    return (
        <AppBar color="inherit" position="fixed" open={open}>
            <Toolbar sx={{ display: 'flex', alignItems: 'center' }}>
                {hideMenuIcon ? null : (
                    <IconButton
                        color="inherit"
                        aria-label="open drawer"
                        onClick={navigationHandler}
                        edge="start"
                        sx={{ mr: 2, ...(open && {}) }}
                    >
                        <MenuIcon />
                    </IconButton>
                )}

                <IconButton sx={{ borderRadius: 0 }}>
                    <Avatar sx={{ width: 80 }} variant="rounded" src={glory_icon} alt="User Avatar" />
                </IconButton>

                <Stack direction="column" alignItems="center" color={Colors.drawerTextColor}>
                    <Typography variant="h6" sx={{ flexGrow: 1, fontSize: 22 }}>
                        OLD GLORY PAY
                    </Typography>

                    <Typography variant="h6" sx={{ flexGrow: 1, fontSize: 14, fontWeight: 600 }}>
                        Business Account
                    </Typography>
                </Stack>
            </Toolbar>
        </AppBar>
    );
}
